import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext, useMemo } from 'react';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { NumberBoxContext } from '../NumberBox.Context/NumberBox.Context.es.js';

const NumberBoxGenericAmount = ({ as: DynamicTag = 'h3', children, locale = 'en-US', units })=>{
    const { loading, fallback } = useContext(NumberBoxContext);
    const amount = useMemo(()=>{
        if (children != null) {
            return Number(children).toLocaleString(locale);
        }
        return fallback;
    }, [
        children,
        fallback,
        locale
    ]);
    return jsx(DynamicTag, {
        className: "amount",
        children: jsxs(SkeletonBox, {
            className: "loading",
            loading: loading,
            children: [
                amount,
                units && children != null && jsx("span", {
                    className: "currency",
                    children: units
                })
            ]
        })
    });
};

export { NumberBoxGenericAmount };
//# sourceMappingURL=NumberBox.GenericAmount.es.js.map
